import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * The custom object type ID for the current route subtree, supplied by the hosting module — e.g. the
 * custom-object module provides the route's `customObjectTypeID`. The shell reads its type ID from
 * here rather than from the route, so the matching stays config-driven and the shell needn't know
 * which custom object type it is hosting.
 */
export const CRM_OBJECT_WORKSPACE_TARGET = new InjectionToken<Observable<string>>('CrmObjectWorkspaceTarget');
